(function () {
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  function samePagePath(pathname) {
    const current = (window.location.pathname || "/").replace(/\/$/, "") || "/";
    const next = (pathname || "/").replace(/\/$/, "") || "/";
    return current === next;
  }

  function getHeaderOffset() {
    const header = document.querySelector(".el-header");
    if (!header) return 16;
    return Math.ceil(header.getBoundingClientRect().height) + 16;
  }

  function scrollToHash(hash, updateHistory) {
    if (!hash || hash === "#") return false;

    let id = "";
    try {
      id = decodeURIComponent(hash.slice(1));
    } catch (error) {
      id = hash.slice(1);
    }

    if (!id) return false;

    const target = document.getElementById(id);
    if (!target) return false;

    const top = target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset();

    window.scrollTo({
      top: Math.max(0, top),
      behavior: reducedMotion.matches ? "auto" : "smooth",
    });

    if (updateHistory && window.history && window.history.pushState) {
      window.history.pushState(null, "", hash);
    }

    return true;
  }

  document.addEventListener("click", (event) => {
    const link = event.target.closest("a[href]");
    if (!link) return;
    if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.hasAttribute("download") || link.getAttribute("target") === "_blank") return;

    let url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (error) {
      return;
    }

    if (url.origin !== window.location.origin) return;
    if (!url.hash || url.hash === "#") return;
    if (!samePagePath(url.pathname)) return;

    const scrolled = scrollToHash(url.hash, true);
    if (scrolled) {
      event.preventDefault();
    }
  });

  function scrollOnLoad() {
    if (!window.location.hash) return;
    window.setTimeout(() => {
      scrollToHash(window.location.hash, false);
    }, 50);
  }

  if (document.readyState === "complete") {
    scrollOnLoad();
  } else {
    window.addEventListener("load", scrollOnLoad);
  }
})();
